"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = WindowControls;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _WindowControlsModule = _interopRequireDefault(require("./WindowControls.module.scss"));

var _inputElements = require("../../inputElements");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function WindowControls(_ref) {
  var _ref$hasCloseBtn = _ref.hasCloseBtn,
      hasCloseBtn = _ref$hasCloseBtn === void 0 ? true : _ref$hasCloseBtn,
      _ref$hasMinimizeBtn = _ref.hasMinimizeBtn,
      hasMinimizeBtn = _ref$hasMinimizeBtn === void 0 ? false : _ref$hasMinimizeBtn,
      onClose = _ref.onClose,
      onMinimize = _ref.onMinimize,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _ref$classNameDragHan = _ref.classNameDragHandler,
      classNameDragHandler = _ref$classNameDragHan === void 0 ? "" : _ref$classNameDragHan,
      _ref$classNameCloseBt = _ref.classNameCloseBtn,
      classNameCloseBtn = _ref$classNameCloseBt === void 0 ? "" : _ref$classNameCloseBt,
      _ref$classNameMinimiz = _ref.classNameMinimizeBtn,
      classNameMinimizeBtn = _ref$classNameMinimiz === void 0 ? "" : _ref$classNameMinimiz,
      style = _ref.style,
      styleDragHandler = _ref.styleDragHandler,
      styleCloseBtn = _ref.styleCloseBtn,
      styleMinimizeBtn = _ref.styleMinimizeBtn;
  var handleClose = (0, _react.useCallback)(function () {
    if (onClose) onClose(); // TODO: interact with WindowManagerContext, need to check particularily if we are allowed to close the window (InGameUiLogicContext)
    // TODO: also, if this would be a particular window, how we open a new window within the WindowManager from here ?
  }, [onClose]);
  var handleMinimize = (0, _react.useCallback)(function () {
    if (onMinimize) onMinimize(); // TODO: see above
  }, [onMinimize]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_WindowControlsModule.default.windowControls, className),
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_WindowControlsModule.default.dragHandler, classNameDragHandler, "windowDragHandler"),
    style: styleDragHandler
  }), hasMinimizeBtn && /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.WINDOW_MINIMIZE,
    className: (0, _classnames.default)(_WindowControlsModule.default.minimizeBtn, classNameMinimizeBtn, "windowMinimizeBtn"),
    style: styleMinimizeBtn,
    onClick: handleMinimize
  }), hasCloseBtn && /*#__PURE__*/_react.default.createElement(_inputElements.Button, {
    type: _inputElements.EButtonType.WINDOW_CLOSE,
    className: (0, _classnames.default)(_WindowControlsModule.default.closeBtn, classNameCloseBtn, "windowCloseBtn"),
    onClick: handleClose,
    style: styleCloseBtn
  }));
}